<div class="w-full max-w-[600px]">
  <div class="mb-3 pt-8 text-center text-3xl font-bold">
    {{ headline }}
  </div>

  <div class="mb-2 whitespace-pre-line text-center">
    <mat-dialog-content>
      {{ toggleExplanation }}
    </mat-dialog-content>
  </div>

  <div class="mb-2 whitespace-pre-line text-center">
    <mat-dialog-content>
      <div class="mx-4 rounded-lg bg-gray-100 p-4">
        {{ toggleLogicDescription }}
      </div>
    </mat-dialog-content>
  </div>

  <div
    class="flex w-full items-center justify-center rounded-b-lg bg-gray-100 text-center"
  >
    <div class="flex w-full flex-col items-center gap-4 p-6">
      <app-primary-button
        class="w-full"
        [text]="confirmButtonText"
        [loading]="isLoading"
        (buttonClicked)="onConfirmClick()"
      ></app-primary-button>

      <app-text-button (click)="onCancelClick()">{{
        cancelButtonText
      }}</app-text-button>
    </div>
  </div>
</div>
